import React from 'react';

const DocumentationPage = () => {
    const CodeBlock = ({ children }) => (
        <pre className="bg-gray-800 text-white p-4 rounded-lg overflow-x-auto text-sm">
            <code>{children}</code>
        </pre>
    );

    return (
        <div className="py-12">
            <div className="container mx-auto px-6">
                <div className="text-center mb-12">
                    <h1 className="text-4xl font-bold text-white">API Documentation</h1>
                    <p className="text-white mt-4 max-w-2xl mx-auto">Integrate Syncratik into your applications with our powerful and easy-to-use API.</p>
                </div>

                <div className="flex flex-col md:flex-row gap-8">
                    {/* Sidebar */}
                    <aside className="w-full md:w-1/4 lg:w-1/5">
                        <div className="sticky top-24">
                            <h3 className="text-lg font-semibold text-white mb-4">API Sections</h3>
                            <ul className="space-y-2">
                                                        <li><a href="#introduction" className="text-white hover:text-[#7B34BB]">Introduction</a></li>
                        <li><a href="#authentication" className="text-white hover:text-[#7B34BB]">Authentication</a></li>
                        <li><a href="#agents" className="text-white hover:text-[#7B34BB]">Agents API</a></li>
                        <li><a href="#knowledge-base" className="text-white hover:text-[#7B34BB]">Knowledge Base</a></li>
                        <li><a href="#errors" className="text-white hover:text-[#7B34BB]">Error Handling</a></li>
                            </ul>
                        </div>
                    </aside>

                    {/* Main Content */}
                    <main className="w-full md:w-3/4 lg:w-4/5">
                        <div id="introduction" className="mb-12">
                            <h2 className="text-2xl font-semibold textwhite mb-4">Introduction</h2>
                            <p className="text-white leading-relaxed">Welcome to the Syncratik API! Our RESTful API allows you to programmatically manage your AI agents, integrate knowledge bases, and initiate calls. All API endpoints are relative to the base URL: <code>https://api.convoai.com/v1</code>.</p>
                        </div>

                        <div id="authentication" className="mb-12">
                            <h2 className="text-2xl font-semibold text-white mb-4">Authentication</h2>
                            <p className="text-white leading-relaxed mb-4">All API requests must be authenticated using an API key. You can generate and manage your API keys from your user profile page in the dashboard. Include your API key in the <code>Authorization</code> header of your requests as a Bearer token.</p>
                            <CodeBlock>
{`Authorization: Bearer YOUR_API_KEY`}
                            </CodeBlock>
                        </div>

                        <div id="agents" className="mb-12">
                            <h2 className="text-2xl font-semibold text-white mb-4">Agents API</h2>
                            <h3 className="text-xl font-semibold text-white mt-6 mb-2">Create an Agent</h3>
                            <p className="text-white leading-relaxed mb-4">To create a new agent, send a POST request to the <code>/agents</code> endpoint.</p>
                            <CodeBlock>
{`POST /v1/agents
Content-Type: application/json
Authorization: Bearer YOUR_API_KEY

{
  "name": "Sales Assistant",
  "voice": "onyx",
  "language": "English",
  "personality": "You are a friendly sales assistant..."
}`}
                            </CodeBlock>

                             <h3 className="text-xl font-semibold text-white mt-6 mb-2">List Agents</h3>
                            <p className="text-white leading-relaxed mb-4">Retrieve a list of all your agents with a GET request to the <code>/agents</code> endpoint.</p>
                             <CodeBlock>
{`GET /v1/agents
Authorization: Bearer YOUR_API_KEY`}
                            </CodeBlock>
                        </div>
                        
                        <div id="knowledge-base" className="mb-12">
                            <h2 className="text-2xl font-semibold text-white mb-4">Knowledge Base API</h2>
                             <p className="text-white leading-relaxed mb-4">The Knowledge Base API allows you to upload and manage documents that your agents can use to answer questions.</p>
                            <h3 className="text-xl font-semibold text-white mt-6 mb-2">Upload a Document</h3>
                            <p className="text-white leading-relaxed mb-4">To upload a document, send a multipart/form-data POST request to the <code>/knowledge-base/upload</code> endpoint.</p>
                             <CodeBlock>
{`POST /v1/knowledge-base/upload
Content-Type: multipart/form-data
Authorization: Bearer YOUR_API_KEY

[form-data with file]`}
                            </CodeBlock>
                        </div>

                        <div id="errors" className="mb-12">
                            <h2 className="text-2xl font-semibold text-white mb-4">Error Handling</h2>
                            <p className="text-white leading-relaxed mb-4">Our API uses standard HTTP status codes to indicate the success or failure of a request. A <code>2xx</code> range indicates success. A <code>4xx</code> range indicates a client-side error (e.g., invalid parameters, authentication failure). A <code>5xx</code> range indicates a server-side error.</p>
                        </div>
                    </main>
                </div>
            </div>
        </div>
    );
};

export default DocumentationPage;

